import { useAPIAction, BlanksDraftApi } from "melco-shared-logic";

export const useAddBlank = () =>
  useAPIAction(
    BlanksDraftApi,
    async (api) => {
      const data = await api.userBlankCreateDraft({
        sharedserviceMelcoFusionModelsCreateBlank: {},
      });

      return {
        successMessages: [
          {
            message: "default",
          },
        ],
        data,
      };
    },
    {
      translationPrefix: "blanks.actions.add",
    }
  );
